import React from 'react';
import './toast.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

interface ErrorToastProps {
  text: string;
  path: string;
}

interface LogsToastProps {
  messages: string[];
  path: string;
}

const CustomErrorToast: React.FC<ErrorToastProps> = ({ text, path }) => {
  const navigate = useNavigate();

  const handleViewLogClick = (path: string) => {
    toast.dismiss();
    navigate(path);
  };

  return (
    <div>
      <p>{text}</p>
      <button className="toast-button" onClick={() => handleViewLogClick(path)}>
        View logs
      </button>
    </div>
  );
};

function PopupLogsList({ items }: { items: string[] }) {
  return (
    <ul>
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
}

const CustomLogsToast: React.FC<LogsToastProps> = ({ messages, path }) => {
  const navigate = useNavigate();
  const handleViewLogClick = (path: string) => {
    toast.dismiss();
    navigate(path);
  };

  return (
    <div>
      <PopupLogsList items={messages} />
      <button className="toast-button" onClick={() => handleViewLogClick(path)}>
        View logs
      </button>
    </div>
  );
};

export default CustomErrorToast;
export { CustomLogsToast };
